import React from "react"
import { Grid } from "@cd2/components/build/es6"
import { H2, P } from "@cd2/text/build/es6"
import { ButtonsWrapper } from "../../../Components/ButtonsWrapper"
import { CustomerFloatingBox } from "../../../Components/Misc/CustomerFloatingBox"

export function BasicHeader({
  number,
  title,
  actions,
  error,
}: {
  number?: number
  title: string
  actions?: React.ReactNode
  error?: string
}) {
  const header = [number && `${number}.`, title].filter(Boolean).join(" ")
  return (
    <CustomerFloatingBox.Header>
      <Grid columns={["auto", "max-content"]} alignItems="center">
        <div>
          <H2>{header}</H2>
          {error && (
            <P size="small" color="red">
              {error}
            </P>
          )}
        </div>
        {actions && <ButtonsWrapper>{actions}</ButtonsWrapper>}
      </Grid>
    </CustomerFloatingBox.Header>
  )
}
